<template>
    <v-col cols="12">
        <v-row justify="center">
            <!-- Book Assigned -->
            <v-card
                data-cy="assignedBook-container"
                elevation="12"
                class="bg-yellow"
                width="99%"
            >
                <v-row class="ma-0 px-6 px-md-12 pt-2 pt-md-6 pb-0 bg-image" justify="center">
                    <v-col cols="12" md="8" v-if="book&&!loading">
                        <v-row class="text-h6 font-weight-bold">
                            {{ $t('home.assigned_book') }}
                        </v-row>
                        <v-row class="my-2 text-h4 font-weight-regular">
                            {{ book.title }}
                        </v-row>
                        <v-row class="pr-12">
                            <p class="text-subtitle-1 text-left">
                                {{ book.bookAbstract }}
                            </p>
                        </v-row>
                        <v-row justify="center" justify-md="start">
                            <v-btn
                                data-cy=assignedBookCard-startReading-btn
                                class="mt-2 no-uppercase"
                                color="#FF6F3A"
                                dark
                                x-large
                                rounded
                                @click="$router.push(`/user/book/${book.id}`)"
                            >
                                {{ $t('home.start_reading') }}
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4" v-if="book&&!loading">
                        <v-row justify="center">
                            <v-img
                                :src="
                                    `https://assets.beereaders.com/lbr/image/${book.resourceDir}/cover_small.jpg`
                                "
                                @click="$router.push(`/user/book/${book.id}`)"
                                class="book-img border-radius-2 cursor-pointer"
                                max-height="300" max-width="230"
                            />
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="pa-0 ma-0" v-if="loading">
                        <v-row class="pa-0 ma-0">
                            <v-col cols="12" md="8" class="pa-0 mt-4">
                                <v-skeleton-loader
                                    class="opacity-none"
                                    height="25"
                                    width="25%"
                                    type="heading"
                                    :transition="'scale-transition'"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    class="opacity-none my-4"
                                    height="35"
                                    width="50%"
                                    type="heading"
                                    :transition="'scale-transition'"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    class="opacity-none"
                                    height="70"
                                    width="80%"
                                    type="paragraph"
                                    :transition="'scale-transition'"
                                ></v-skeleton-loader>
                                <v-row justify="center" justify-md="start" class="ma-0">
                                    <v-skeleton-loader
                                        class="opacity-none"
                                        height="60"
                                        width="220"
                                        type="button"
                                        :transition="'scale-transition'"
                                    ></v-skeleton-loader>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-row justify="center">
                                    <v-skeleton-loader
                                        class="opacity-none"
                                        height="300"
                                        width="230"
                                        type="image"
                                        :transition="'scale-transition'"
                                    ></v-skeleton-loader>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-overlay absolute :value="!book" opacity="0.6">
                        <v-row class="ma-0 pa-12 text-h6 text-md-h4 font-weight-regular" justify="center" align="center">
                            {{ $t('home.no_book')}}
                        </v-row>
                    </v-overlay>
                </v-row>
            </v-card>
        </v-row>
    </v-col>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import CourseBookService from '../../services/courseBook'

export default {
    data() {
        return {
            book: true,
            loading: true
        }
    },
    created () {
        this.getAssignedBook()
    },
    computed: {
        ...mapState({
            course: (state) => state.userData.user.course,
        }),
    },
    methods: {
        ...mapActions('userData', ['setExistAssignedBook', 'setAssignedBookId', 'setRemainDays']),
        formatDate(date) {
            const d = new Date(date)
            let month = `${(d.getMonth() + 1)}`
            let day = `${d.getDate()}`
            const year = d.getFullYear()

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join("-");
        },
        getAssignedBook () {
            CourseBookService.getBookListByCourseAndDate({
                userCourseId: this.course.id,
                bookDate: this.formatDate(new Date())
            })
            .then((response) => {
                this.setBookAssigment(response.content[0])
                if (response.content[0]) {
                    this.setExistAssignedBook(true)
                    this.setAssignedBookId(response.content[0].id)
                } else {
                    this.setExistAssignedBook(false)
                }
            })
            .catch((error) => console.error(error))
        },
        setBookAssigment (data) {
            this.book = data
            this.loading = false
        }
    }
}
</script>

<style scoped>
.bg-yellow {
    background: rgb(255,208,51);
    background: linear-gradient(90deg, rgba(255,208,51,1) 0%, rgba(255,214,80,1) 60%, rgba(255,221,120) 100%);
    border-radius: 40px;
}
.bg-image {
    background-image: url("/img/user/book-assigned-bg.svg");
    background-repeat: no-repeat;
    background-position: 50% 0;
    background-size: cover;
    min-height: 35vh;
}

@media (max-width: 959px) {
    .bg-image {
        background-position: 50% 200%;
        height: 600px;
    }
}

.no-uppercase {
     text-transform: none;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__button {
    width: 100%;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__heading {
    height: 100%;
    width: 100%;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__image {
    height: 100%;
    width: 100%;
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__paragraph {
    height: 100%;
    width: 100%;
}

.book-img {
  box-shadow: 0 0 18px -1px hsl(0, 0%, 44%);
}

</style>
